<ng-container *ngIf="pageData;else loading">
  <div class="pageContainer tabcontent storyNew" id="allStories" style="display:block;">
    <div class="tabs ">
      <span class="tablinks bold cursor_auto toggleheading" onclick="opentab(event, 'allStories')"
        id="defaultOpen">{{pageData?.name}}</span>
        <div *ngIf="pageData.pageType && (pageData.pageType == 'EXTERNAL' || pageData.pageType == 'TOPIC' || pageData.pageContentEnabled)" class="toggleBtn">
          <p>Page lineup</p>
          <div class="checkbox">
                  
            <label class="switchN" >
              
              <input type="checkbox" (click)="switchToggle()" [checked]="contentChecked" />
              <div class="slider1 round"></div>
             
            </label>
            </div>
            <p>Page content</p>
        </div>
        

      <button type="button" name="createCard" *ngIf="!pageEditMode && !(accessType=='View')" (click)="unlockPage()" class="blue  m0c togglebtnRight">
        Unlock page
      </button>

      <div class="secondaryCta fr" *ngIf="this.pageData.status === 'PUBLISHED'" #secondaryCTAs>
        <span class="threedots" (click)="revertListFlag = !revertListFlag">
          <span></span>
          <span></span>
          <span></span>
        </span>
        <div class="revertStoryBlock" *ngIf="revertListFlag">
          <ul>

            <li>
              <button (click)="purgePage()">
                Purge Page
              </button>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="tabcontainer pageEditor" *ngIf="pageData.design !== 'template' && pageData.pageType !== 'EXTERNAL' && !contentChecked">
      <div class="">
        <div class="allContent">

          <h4>All Content</h4>
          <div class="blockContain">
            <div class="custom-select" *ngIf="(pageData.design !== 'list' || isCardViewEnabled('elements') || !sharedService.isdomainConfig('pages','showDomainFilter'))">
              <select [(ngModel)]="Category" class="fr" id="category">
                <option value="story" selected>story</option>
                <option value="elements">elements</option>
              </select>
            </div>
            <div *ngIf="Category == 'story'" class="app-page-listing" isPage="story" [pageManager]="true"
              pageId="all_stories" allApi="all_story" showSearch="true" [mergeArticles]="mergeArray" getDragulaId="left"
              searchApi="search_story" metaApi="dashboard_meta" pageArticleApi="page_putArticle">
            </div>
            <div *ngIf="Category == 'elements'" class="app-page-listing" isPage="elements" [pageManager]="true"
              [mergeArticles]="mergeArray" pageId="element" allApi="all_elements" showSearch="true" getDragulaId="left"
              searchApi="search_elements" metaApi="element_meta" pageArticleApi="page_putArticle">

            </div>
            <div class="lockbg" *ngIf="!pageEditMode"></div>
          </div>
        </div>
        <div class="livePage" *ngIf="pageData.pageType !== 'EXTERNAL'">
          <h4>Line-up</h4><i class="clearLineUp icon-clear_chache" (click)="openLineupPopup()"
            title="Clear Line-up"></i>
          <div class="blockContain">
          <div *ngIf="pageData.breakingNewsId" class="breakingNewsPage">
            <!--   <div class="breakingNewsPage"> -->
              <label>Latest Breaking News</label>
              <span class="deleteHeadline" (click)="deleteBreakingNews()">
                <i class="icon-delete"></i>
              </span>
            </div>
            <div #lineupElement class="app-page-listing" pageId="pages" allApi="page_list" isPage="elements"
              showSearch="false" getDragulaId="right" [showPageId]="pageData.id" [pagePinIds]="pushPinnedArticles"
              (sendListIdToParentfn)="getListIdToParentfn($event)"
              (sendPageArticleIdToParentfn)="getArticleIdToParentfn($event)" pageArticleApi="page_putArticle">
            </div>
            <div class="lockbg" *ngIf="!pageEditMode"></div>
            <div class="lockbg" *ngIf="showlockBg" (click)="showlockBg = false"></div>
          </div>
        </div>
      </div>
    </div>
    <div class="tabcontainer marb20" #tabcont *ngIf="pageData.design === 'template' && !contentChecked">
      <div class="formStory fl100" [ngStyle]="setStoryHeight()" #formStory>
        <div class="rootContainer" (drop)="zoneDrop($event)" (dragover)="allowDrop($event)">
          <div class="app-template rootCol" [templateData]="pageData.template" [align]="pageData.template.alignment"
            (updateZoneTemplate)="getZoneData($event)" [existingElements]="allCollections"
            [elementDesigns]="componentDesigns"></div>
        </div>
      </div>
    </div>
    <app-page-inline *ngIf="contentChecked" [pageData]="pageData" [lastindex]="lastindex" [changeFlag]="changeFlag" [viewPortItems]="viewPortItems"
        (generateAutoSave)="generateAutoSave()" (destroyAutoSave)="destroyAutoSave()"></app-page-inline>
    <div class="clearBoth"></div>
  </div>
  <div class="thirdContainScroll">
    <div class="thirdContainer">
      <ng-container *ngIf="disabledPreviews.length < 2">
      <div class="preview padb20 fl100">Preview
        <span class="right fr">
          <a #preivewMobile tabindex="0" (click)="openPreview('mobile')">
            <span class="molineLink">
              <i class="icon-mobile"></i>Mobile</span>
          </a>
          <a #preivewDesktop tabindex="0" (click)="openPreview('desktop')">
            <span class="desktopLink">
              <i class="icon-desktop"></i>Desktop</span>
          </a>
        </span>
      </div>
      </ng-container>
      <div class="usermeta blocks marb20">
        <div class="head">Metadata</div>
        <div class="form">
            <ul class="bylineBlock">
                <li *ngIf="disabledMetaFields.indexOf('byline') === -1">
                  <label>By Line</label>
                  <div class="dataField">
                    <tags-creator [autoSuggest]="true" [autocompletelist]="authorsSuggestion" (focusoutfn)="disableInnerFocus($event)"
                      [editable]="!pageEditMode" [data]="pageData.metadata.authors" [setFocus]="innerFocusFlag"
                      [displayText]="'Add Byline here..'" (clickfn)="customFunc($event)" (changefn)="pageData.metadata.authors = $event"
                      (focusedfn)="catchTagFocus($event)"></tags-creator>
                  </div>
                </li>
                <ng-container *ngFor="let field of fieldSet">
                  <ng-container *ngIf="disabledMetaFields.indexOf(field.metadataModelId) === -1">
                  <li *ngIf="disableElement('meta-more') ? pageData.metadata[field.metadataModelId] ? pageData.metadata[field.metadataModelId].length > 0 : false : true">
                    <ng-container *ngIf="!field.auto">
                      <label>{{field.labelName}}</label>

                      <div class="dataField">
                        <ul id="myAuthors">
                          <tags-creator [data]="pageData.metadata.agencyByLine" [editable]="!pageEditMode" [displayText]="'Agency Byline'"
                            (clickfn)="customFunc($event)" (changefn)="pageData.metadata.agencyByLine = $event"
                            (focusedfn)="catchTagFocus($event)"></tags-creator>
                        </ul>
                      </div>
                    </ng-container>
                    <ng-container *ngIf="field.auto">
                      <label>{{field.labelName}}</label>
                      <div class="dataField">
                        <ul id="myAuthors">
                          <tags-creator [autoSuggest]="true" [autocompletelist]="authorsSuggestion" [setFocus]="field.focusFlag"
                            [editable]="!pageEditMode" [data]="getValuefromThis(field.dataModelId)" [displayText]="field.inputPlaceholder"
                            (clickfn)="customFunc($event)" (changefn)="pageData.metadata[field.metadataModelId] = $event"
                            (focusedfn)="catchTagFocus($event)"></tags-creator>
                        </ul>
                      </div>
                    </ng-container>
                  </li>
                </ng-container>
                </ng-container>
                <ng-container *ngIf="disabledMetaFields.indexOf('column') === -1">
                <li >
                  <label>Column</label>
                  <div class="dataField">
                    <input type="text" [class]="'textBox'" #columnInput [readonly]="!pageEditMode" placeholder="Add Column here."
                      [(ngModel)]="columnQuery" (keyup)="filterAutoCompleteUp($event ,'column')" (keydown)="filterAutoCompleteDown($event ,'column')"
                      (focus)="focusInSuggest('column')" (focusout)="false">
                    <ng-container *ngIf="pageEditMode">
                      <div #columnList class="autosuggestion block" *ngIf="filteredColumnSuggestion && filteredColumnSuggestion.length > 0">
                        <ul *ngFor="let item of filteredColumnSuggestion; let i = index">
                          <li (click)="selectAutoComplete('column', item)" [class.active]="i === currentSelection">
                            <span class="name">{{item}}</span>
                          </li>
                        </ul>
                      </div>
                      <ng-container *ngIf="insideColumn && (1 > filteredColumnSuggestion.length)">
                        <div class="autosuggestion block">
                          <ul>
                            <li>
                              <span class="name">No Results</span>
                            </li>
                          </ul>
                        </div>
                      </ng-container>
                    </ng-container>
                  </div>
                </li>
                </ng-container>
                <ng-container *ngIf="isMoreButtonEnabled">
                <li>
                  <span [class]="(disableElement('meta-more') ? 'more' : 'less') + ' spImg_story'" (click)="metaToggleFlag = !metaToggleFlag">
                    {{disableElement('meta-more') ? 'more' : 'less'}}
                  </span>
                </li>
              </ng-container>
              </ul>
          <ul>
            <li>
              <label>Name</label>
              <div class="dataField">
                <input type="text" class="textBox" [readOnly]="!pageEditMode || (pageData.pageType === 'AGENCY') || (pageData.pageType === 'BRUNCH')"
                  id="{{pageData.name}}" [(ngModel)]="pageData.name" placeholder="Add page name here…" [disabled]="pageData.pageType =='SERIES'?true:false">
              </div>
            </li>
            <li *ngIf="pageData.pageType == 'SERIES'">
              <label>Short Name</label>
              <div class="dataField">
                <input type="text" class="textBox" [readOnly]="!pageEditMode || (pageData.pageType === 'AGENCY') || (pageData.pageType === 'BRUNCH')"
                  id="{{pageData.shortName}}" [(ngModel)]="pageData.shortName" placeholder="Add page short name here…">
              </div>
            </li>
            <li *ngIf="pageData.pageType == 'SERIES'">
              <label>Display Name</label>
              <div class="dataField">
                <input type="text" class="textBox" [readOnly]="!pageEditMode || (pageData.pageType === 'AGENCY') || (pageData.pageType === 'BRUNCH')"
                  id="{{pageData.displayName}}" [(ngModel)]="pageData.displayName" placeholder="Add page display name here…">
              </div>
            </li>
            <li *ngIf="pageData.pageType == 'SERIES'">
              <label>Series Tour ID</label>
              <div class="dataField">
                <input type="text" class="textBox" [readOnly]="!pageEditMode || (pageData.pageType === 'AGENCY') || (pageData.pageType === 'BRUNCH')"
                  id="{{pageData.siTourId}}" [(ngModel)]="pageData.siTourId" placeholder="Add series tour Id here…">
              </div>
            </li>
            <li *ngIf="pageData.pageType == 'SERIES'">
              <label>Series ID</label>
              <div class="dataField">
                <ul id="myKeyword" class="tagit">
                  <li class="tagit-new">
                    <tags-creator [data]="pageData.seriesId" [editable]="!pageEditMode"
                      [displayText]="'Add series ids here..'" (changefn)="pageData.seriesId = $event"></tags-creator>
                  </li>
                </ul>
              </div>
            </li>
            <li *ngIf="(pageData.pageType == 'SUBSECTION' || pageData.pageType == 'TOPIC') && !!pageData.parentSection">
              <label>Section</label>
              <div class="dataField">
                <input type="text" class="textBox" readOnly id="{{pageData.parentSection.name}}"
                  [(ngModel)]="pageData.parentSection.name">
              </div>
            </li>
            <li *ngIf="pageData.pageType == 'TOPIC' && pageData.metadata.marketTopicPage && domainConfig['config']['pages']['topicStockUrl']">
              <label>Stock</label>
              <div class="dataField">
                <input type="text" class="textBox" readOnly id="{{pageData.metadata.marketStockId}}"
                  [(ngModel)]="pageData.metadata.marketStockName">
              </div>
            </li>
            <li  *ngIf="pageData.pageType == 'SECTION'|| pageData.pageType === 'COMPANY' || pageData.pageType == 'TOPIC' || (isCardViewEnabled('card') && pageData.pageType == 'SUBSECTION')">
              <label>Design</label>
              <div class="dataField">
                <input type="text" class="textBox" readOnly [disabled]="pageData.design === 'template'"
                  [(ngModel)]="pageQuery" (click)="filterAutoComplete()">
                <div #designOptions>
                  <div class="autosuggestion block" *ngIf="filteredpageDesign && filteredpageDesign.length > 0">
                    <ul *ngFor="let item of filteredpageDesign">
                      <ng-container *ngIf="item.value !== 'template'">
                        <li (click)="selectAutoCompletePage(item)">
                          <span class="name">{{item.value}}</span>
                        </li></ng-container>
                    </ul>
                  </div>
                  <ng-container *ngIf="(filteredpageDesign.length < 0)">
                    <div class="autosuggestion block">
                      <ul>
                        <li>
                          <span class="name">No Results</span>
                        </li>
                      </ul>
                    </div>
                  </ng-container>
                </div>
              </div>
            </li>

            <li *ngIf="pageData.design === 'template'">
              <ng-container *ngIf="(pageData.status === 'PUBLISHED')">
                <label>Template Design</label>
                <div class="dataField">
                  {{pageData.template.name}}
                </div>
              </ng-container>
              <ng-container
                *ngIf="(pageData.status !== 'PUBLISHED') && (templateType !== null) && (templateTypes.length > 0)">
                <label>Template Design</label>
                <div class="dataField">
                  <select [(ngModel)]="templateType" (ngModelChange)="changeTemplateDesign($event)"
                    [compareWith]="compareFn">
                    <ng-container *ngFor="let c of templateTypes">
                      <option [selected]="templateType == c" [ngValue]="c">{{c.name}}</option>
                    </ng-container>
                  </select>
                </div>
              </ng-container>
            </li>
            <li>
              <label>Title</label>
              <div class="dataField">
                <input type="text" class="textBox" [readOnly]="!pageEditMode" id="{{pageData.title}}"
                  [(ngModel)]="pageData.title" placeholder="Add meta title here…">
              </div>
            </li>
            <li *ngIf="pageData.pageType==='BRUNCH'">
              <label>Edition Date</label>
              <div class="dataField">
                <input type="date" class="textBox" [readOnly]="!pageEditMode || (pageData.pageType === 'BRUNCH')" id="{{pageData.editionDate}}"
                [ngModel]="pageData.editionDate | date: 'yyyy-MM-dd'" (ngModelChange)="updateEditionDate($event)" placeholder="Add edition date">
              </div>
            </li>
            <li *ngIf="pageData.pageType==='BRUNCH'">
              <label>Edition Text</label>
              <div class="dataField">
                <textarea appTextareaAutoresize [readOnly]="!pageEditMode" class="textAreaBox" [(ngModel)]="pageData.editionText"
                  placeholder="Add edition text here…"></textarea>
              </div>
            </li>
            <li>
              <label>Keywords</label>
              <div class="dataField">
                <ul id="myKeyword" class="tagit">
                  <li class="tagit-new">
                    <tags-creator [data]="pageData.keywords" [editable]="!pageEditMode"
                      [displayText]="'Add keywords here..'" (changefn)="pageData.keywords = $event"></tags-creator>
                  </li>
                </ul>
              </div>
            </li>
            <li *ngIf="pageData.pageType === 'TOPIC'">
              <label>Synonyms</label>
              <div class="dataField">
                <ul id="myKeyword" class="tagit">
                  <li class="tagit-new">
                    <tags-creator [data]="pageData.synonymsList" [editable]="!pageEditMode"
                      [displayText]="'Add synonyms here..'" (changefn)="pageData.synonymsList = $event"></tags-creator>
                  </li>
                </ul>
              </div>
            </li>
            <li *ngIf="pageData.pageType == 'PRIMARY'">
              <label>
                Section
              </label>
              <div id="inputAddSectionText" class="dataField">
                <input type="text" class="textBox" #sectionInput [readonly]="!pageEditMode" placeholder="Add Section here."
                  [(ngModel)]="sectionQuery" (keyup)="filterAutoCompleteUp($event ,'section')" (keydown)="filterAutoCompleteDown($event ,'section')"
                  (focus)="focusInSuggest('section')" (focusout)="false">
                <ng-container *ngIf="pageEditMode">
                  <div #sectionList class="autosuggestion block" *ngIf="filteredSectionSuggestion && filteredSectionSuggestion.length > 0 && insideSection">
                    <ul *ngFor="let item of filteredSectionSuggestion;let i = index">
                      <li (click)="selectAutoComplete('section', item)" [class.active]="i === currentSelection">
                        <span class="name">{{item}}</span>
                        <!-- <span class="emails">(nitesh.rawal@htdigital.in)</span> -->
                      </li>
                    </ul>
                  </div>
                  <ng-container *ngIf="insideSection && (!filteredSectionSuggestion || 1 > filteredSectionSuggestion.length)">
                    <div class="autosuggestion block">
                      <ul>
                        <li>
                          <span class="name">No Results</span>
                        </li>
                      </ul>
                    </div>
                  </ng-container>
                </ng-container>

              </div>
            </li>
            <li *ngIf="pageData.pageType == 'PRIMARY'">
              <label>Sub-section
              </label>

              <div id="inputAddSubSectionText" class="dataField">
                <input type="text" class="textBox" #subSectionInput [readonly]="!pageEditMode"
                  placeholder="Add SubSection here." [(ngModel)]="subSectionQuery" (keyup)="filterAutoCompleteUp($event ,'subSection')"
                  (keydown)="filterAutoCompleteDown($event ,'subSection')" (focus)="focusInSuggest('subSection')"
                  (focusout)="false">
                <ng-container *ngIf="pageEditMode">
                  <div #subSectionList class="autosuggestion block" *ngIf="filteredSubSectionSuggestion && filteredSubSectionSuggestion.length > 0">
                    <ul *ngFor="let item of filteredSubSectionSuggestion; let i = index">
                      <li (click)="selectAutoComplete('subSection', item)" [class.active]="i === currentSelection">
                        <span class="name">{{item}}</span>
                        <!-- <span class="emails">(nitesh.rawal@htdigital.in)</span> -->
                      </li>
                    </ul>
                  </div>
                  <ng-container *ngIf="insideSubSection && (!filteredSubSectionSuggestion || 1 > filteredSubSectionSuggestion.length)">
                    <div class="autosuggestion block">
                      <ul>
                        <li>
                          <span class="name">No Results</span>
                        </li>

                      </ul>
                    </div>
                  </ng-container>
                </ng-container>
              </div>
            </li>
            <li>
              <label>Description</label>
              <div class="dataField" #descEl>
                <ng-container *ngIf="!sharedService.isdomainConfig('story','newsletter-fields')">
                <textarea type="text" class="textBox" id="{{pageData.description}}" [readOnly]="!pageEditMode"
                [(ngModel)]="pageData.description" placeholder="Add description here…"></textarea>
              </ng-container>
                <ng-container *ngIf="sharedService.isdomainConfig('story','newsletter-fields')">
                <ckeditor #editorDescription id="editor" [(ngModel)]="pageData.description" [editor]="ckEditor"
                [config]="ckconfig" [tabindex]="0" (ready)="ckchanges($event, 'ready', 'desc')"
                (blur)="ckchanges($event, 'blur', 'desc')" (change)="ckchanges($event, 'change', 'desc')"
                (focus)="ckchanges($event, 'focus', 'desc')" (error)="ckchanges($event, 'error', 'desc')"></ckeditor>
                </ng-container>
              </div>
            </li>
            <li>
              <label>Auto-Backlinking Enabled</label>
               <div class="dataField">
              <label class="switch" tabindex="0">
                <input
                  type="checkbox"
                  (click)="toggleSwitch('autobacklink')"
                  [checked]="pageData.toBeAutobacklink"/>
                <span class="slider round"></span>
              </label>
            </div>
            </li>
            <li *ngIf="pageData.pageType == 'EXTERNAL'">
              <label>No Follow</label>
               <div class="dataField">
              <label class="switch" tabindex="0">
                <input
                  type="checkbox"
                  (click)="toggleSwitch('noFollow')"
                  [checked]="pageData.noFollow"/>
                <span class="slider round"></span>
              </label>
            </div>
            </li>
            <li *ngIf="pageData.pageType == 'TOPIC'">
              <label>Proper Noun</label>
               <div class="dataField">
              <label class="switch" tabindex="0">
                <input
                  type="checkbox"
                  (click)="toggleSwitch('propernoun')"
                  [checked]="pageData.properNoun"/>
                <span class="slider round"></span>
              </label>
            </div>
            </li>
            <li *ngIf="sharedService.isdomainConfig('story','newsletter-fields')">
              <label>Additional Info</label>
              <div class="dataField" #infoEl>
                <ckeditor #editorAdditionalInfo id="editor" [(ngModel)]="pageData.additionalInfo" [editor]="ckEditor2"
                [config]="ckconfig" [tabindex]="0" [config]="ckconfig" [tabindex]="0" (ready)="ckchanges($event, 'ready', 'info')" (change)="ckchanges($event, 'change', 'info')"
                (blur)="ckchanges($event, 'blur', 'info')" (focus)="ckchanges($event, 'focus', 'info')" (error)="ckchanges($event, 'error', 'info')"></ckeditor>
              </div>
            </li>
            
            <ng-container *ngIf="sharedService.isdomainConfig('pages','pageSubtype')">
              <li *ngIf="pageData.pageType === 'EXTERNAL'">
                <label>Page Subtype</label>
                <div class="dataField" #infoEl>
                  <tags-creator [textEdit]="pageData.pageSubtype && pageData.pageSubtype.length > 0" [autoSuggest]="true" [autocompletelist]="(pageData.pageSubtype && pageData.pageSubtype.length > 0) ? [] : ['brand','model']"
                    [data]="pageData.pageSubtype ? [pageData.pageSubtype] : null" [noMinReq]="(pageData.pageSubtype && pageData.pageSubtype.length > 0) ? 'false' : 'true'"
                [displayText]="'Add Page Subtype here....'" (clickfn)="customFunc($event)" (changefn)="setType('pageSubtype', $event)"
                ></tags-creator>
                </div>
              </li>
              <li *ngIf="pageData.pageType === 'EXTERNAL'">
                <label>Page Subtype Category</label>
                <div class="dataField" #infoEl>
                  <tags-creator [textEdit]="pageData.pageSubtypeCategory && pageData.pageSubtypeCategory.length > 0" [autoSuggest]="true" [autocompletelist]="(pageData.pageSubtypeCategory && pageData.pageSubtypeCategory.length > 0) ? [] : autocompletelist"
                    [data]="pageData.pageSubtypeCategory ? [pageData.pageSubtypeCategory] : null" [noMinReq]="(pageData.pageSubtypeCategory && pageData.pageSubtypeCategory.length > 0) ? 'false' : 'true'"
                [displayText]="'Enter Page subtype category...'" (clickfn)="customFunc($event)" (changefn)="setType('pageSubtypeCategory', $event)"
                ></tags-creator>
                </div>
              </li>
            </ng-container>
            <li *ngIf="pageData.pageType === 'SECTION' || pageData.pageType === 'COMPANY' || pageData.pageType === 'SUBSECTION'">
              <label >Display Name</label>
              <div class="dataField">
                <input type="text" class="textBox" [readOnly]="!pageEditMode"
                  id="{{pageData.sectionDisplayName}}" [(ngModel)]="pageData.sectionDisplayName" placeholder="Add Display Name here…">
              </div>
            </li>
            <li *ngIf="sharedService.isdomainConfig('pages','revenueSpecial')">
            <label>Revenue Specials</label>
            <div class="dataField">
              <label class="switch" tabindex="0">
                <input
                  type="checkbox"
                  (click)="toggleSwitch('revenueSpecial')"
                  [checked]="pageData.metadata.revenueSpecial"/>
                <span class="slider round"></span>
              </label>
            </div>
            </li>
            <li>
              <label>Cover Image</label>
              <div class="dataField">
                <div class="uploadimage" *ngIf="pageEditMode"><i class="icon-upload"></i>
                  <div class="upload-btn-wrapper relative">
                    <span class="btn">Upload Image</span>
                    <input type="file" name="myfile" (change)="onFileChange($event,'coverImage')" />
                  </div>
                </div>
                <span *ngIf="pageData.coverImage && !pickStoryImageLoad && !croppingInProgress" class="deleteImage" (click)="deleteImage('cover')"><i class="icon-delete"></i></span>
                <div class="cover-image">
                  <ng-container *ngIf="(pickStoryImageLoad || croppingInProgress) && imageType === 'coverImage' ">
                    <div class="imagepreloader">
                      <div class="a" style="--n: 5;">
                        <div class="dot dot1" style="--i: 0;"></div>
                        <div class="dot dot2" style="--i: 1;"></div>
                        <div class="dot dot3" style="--i: 2;"></div>
                        <div class="dot dot4" style="--i: 3;"></div>
                      </div>
                    </div>
                  </ng-container>
                  <ng-container  *ngIf="pageData.coverImage && !pickStoryImageLoad && !croppingInProgress">
                    <img src="{{pageData.coverImage}}" width="173"
                      height="76" />
                  </ng-container>
                  </div>
              </div>
            </li>
              <ng-container *ngIf="pageData.coverImage && !pickStoryImageLoad && !croppingInProgress">
                <li>
                  <label>Image Caption</label>
                  <div class="dataField">
                    <input type="text" class="textBox" [readOnly]="!pageEditMode" id="{{pageData.imageCaption}}"
                      [(ngModel)]="pageData.imageCaption" placeholder="Add image Caption here…">
                  </div>
                </li>
              </ng-container>
              <li>
              <ng-container *ngIf="pageData.pageType!='AGENCY' &&  sponsorImageFlag">

              <label>Sponsor Image</label>
              <div class="dataField">
                <div class="uploadimage" *ngIf="pageEditMode"><i class="icon-upload"></i>
                  <div class="upload-btn-wrapper relative">
                    <span class="btn">Upload Image</span>
                    <input type="file" name="myfile1" (change)="onFileChange($event,'sponsorImage')" />
                  </div>
                  <!-- <div class="cover-action"><span>view</span><span>change
            <input type="file" name="myfile" (change)="onFileChange($event, 'elements')" /> </span></div> -->
                </div>
                <div class="cover-image">
                  <ng-container *ngIf="(pickStoryImageLoad || croppingInProgress) && imageType === 'sponsorImage' ">
                    <div class="imagepreloader">
                      <div class="a" style="--n: 5;">
                        <div class="dot dot1" style="--i: 0;"></div>
                        <div class="dot dot2" style="--i: 1;"></div>
                        <div class="dot dot3" style="--i: 2;"></div>
                        <div class="dot dot4" style="--i: 3;"></div>
                      </div>
                    </div>
                  </ng-container>
                  <ng-container  *ngIf="pageData.sponsorImage && !pickStoryImageLoad && !croppingInProgress">
                    <img src="{{pageData.sponsorImage}}" width="173"
                      height="76" />
                  </ng-container>
                  </div>
              </div>
            </ng-container>
            </li>
            <li>
              <ng-container *ngFor="let newMeta of newMetas; index as i">
                <ng-container *ngIf="(newMeta.pageType.indexOf(pageData.pageType.toLowerCase()) > -1) && newMeta.active">
                    <new-metadata [editable]="pageEditMode" [addedMeta]="newMeta" [checkedField]="getPageDynamicMetaIndex(newMeta.field)"
                    (emitToggleValue)="saveDynamicMetaValue($event,newMeta.field)">
                    </new-metadata>
                </ng-container>
              </ng-container>
            </li>

          </ul>
        </div>
      </div>
      <div class="systemmeta blocks marb20">
        <div class="head">Page Info</div>
        <div class="form">
          <ul>
            <li *ngIf="pageData.pageType === 'EXTERNAL'">
              <label>HTML / CSS Class</label>
              <div class="dataField"><span class="">{{pageData.cssHTMLClass}}</span></div>
            </li>
            <li>
              <label>{{( pageData.pageType !== 'EXTERNAL' ? 'URL' : 'External URL')}}</label>
              <div class="dataField">
                <a href="{{( pageData.pageType !== 'EXTERNAL' ? getPageUrl(pageData.url) : getPageUrl(pageData.externalUrl))}}" target="_blank">
                  <span class="link">{{( pageData.pageType !== 'EXTERNAL' ? getPageUrl(pageData.url) : getPageUrl(pageData.externalUrl))}}</span></a>
                    <span class="editBtn">
                    <span><i (click)="copyPageUrl()" class="icon-cards"></i></span></span>
              </div>
            </li>
            <li>
              <label>Format</label>
              <div class="dataField"><span class="">{{pageData.pageType}}</span></div>
            </li>
          </ul>
        </div>
      </div>
      <div class="storytime blocks">
        <div class="head">Page Timeline</div>
        <div class="form">

          <div class="tiimeline">
            <ng-container *ngFor="let item of listOfHistoryArray;let i = index">
              <div class="block" *ngIf="i < 5">
                <div class="updateby">
                  <p>Date</p>
                  <div class="author">{{item.name}} </div>
                </div>
                <div class="time">{{getVersionDate(+item.historyDate)}}</div>
              </div>
            </ng-container>
            <ng-container *ngIf="pageData.createdBy">
              <div class="block">
                <div class="updateby">
                  <p>Created By</p>
                  <div class="author">{{pageData.createdBy}} </div>
                </div>
                <div class="time">{{getVersionDate(pageData.creationDate)}}</div>
              </div>
            </ng-container>
          </div>
          <!-- <div id="page_saveBtn">
          <span class="created">
            {{changeFlag ? 'SAVING CHANGES...': 'ALL CHANGES ARE SAVED'}}</span>
          <button type="button" (click)="savePage(true)" class="green">Publish</button>
        </div> -->
        </div>
      </div>
    </div>
  </div>

  <div class="image-cropper" *ngIf="showCropper && imageType === 'coverImage'" [pageType]="pageData.pageType" [cropperImageUrl]="cropperImageUrl" (finish)="finishCropping($event,imageType)"
    (cancel)="cancelCropping($event)"></div>

  <div class="image-cropper" *ngIf="showCropper && imageType ==='sponsorImage' " [cropperImageUrl]="cropperImageUrl" (finish)="finishCropping($event,imageType)"
    (cancel)="cancelCropping($event)"></div>


  <div class="lightBox readstory clearLineUpBlock block" *ngIf="deleteLineupPopup">
    <div class="unlockStory">
      <div class="wid100 pad30">
        <h3>Clean Line-up</h3>
        <p>Do you want to clear all stories in Line-up? This action cannot be reversed</p>
      </div>
      <div class="fr wid100 right ptb15">
        <button type="button" name="cancel" (click)="closeLineupPopup()" class="cancel gray">Cancel</button>
        <button type="button" name="unlock" (click)="clearPageLineup()" class="add blue">Confirm</button>
      </div>
    </div>
  </div>

  <div class="viewPreview lightBox block" *ngIf="previewPopup">
    <div class="headerLight">
      <div class="close fl spImg" (click)="closePreview()"></div>
    </div>
    <ng-container *ngIf="previewUrl !== null">
      <div [class]="((previewPlatform === 'mobile') ? 'previewContainer mobile' : 'previewContainer desktop')">
        <!-- [innerHTML]="previewUrl"> -->
        <div class="loaderimage loaderimagepreview block">
          <div class="imagepreloader">
            <div class="a" style="--n: 5;">
              <div class="dot dot1" style="--i: 0;"></div>
              <div class="dot dot2" style="--i: 1;"></div>
              <div class="dot dot3" style="--i: 2;"></div>
              <div class="dot dot4" style="--i: 3;"></div>
            </div>
          </div>
        </div>
        <iframe appIframeTracker [src]="previewUrl" [style]="iframeStyle" (load)="iframeLoaded($event)"></iframe>
        <!-- (click)="return false" (dblclick)="return false" -->
      </div>
    </ng-container>
  </div>

</ng-container>
<ng-template #loading>
  <div class="imagepreloader">
    <div class="a" style="--n: 5;">
      <div class="dot dot1" style="--i: 0;"></div>
      <div class="dot dot2" style="--i: 1;"></div>
      <div class="dot dot3" style="--i: 2;"></div>
      <div class="dot dot4" style="--i: 3;"></div>
    </div>
  </div>
</ng-template>